export default __webpack_public_path__ + "static/media/classtrack_WF.408807ec.png";